import axios from "axios";

export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async getNew({state}, payload) {
            if (!state) {
                return;
            }
            const response = await axios.get('/api/page/' + payload.id);
            return response.data;
        },
        async getNews({state}, payload = {}) {
            if (!state) {
                return;
            }
            let url = '/api/pages/news';

            const limit = Object.prototype.hasOwnProperty.call(payload, 'limit') ? payload.limit : null;
            if (limit) {
                url += '?limit=' + limit;
            }
            const response = await axios.get(url);
            return response.data;
        },

    }
};
